import { Auth } from "@saasbase-io/loginflow-websdk";

export * from "@/components/wrappers";
export * from "@/components/widgets";
export * from "@/components/ui";
export * from "@/components/renderers";
export * from "@/events";

export function useAuthProvider() {
  return Auth;
}
